
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import i09 from "../../img/1280/16x9/paypal.jpg"

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={i09} mdxType="Image" />
    <h1>{`PayPal`}</h1>
    <p>{`Nun hast du Zugriff auf Bella#s Paypal-Account. Du kannst darüber nicht nur
Bezahlungen tätigen, sondern erfährst auch wo sie wohnt und wann sie geboren
ist. In welcher Stadt wohnt Bella?`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;